// ##### 25-02-05 Komarov
import { Select } from 'antd';
import uniqueId from 'lodash.uniqueid';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../../../../hooks/useLocalizedText.js';

// ##### Komarov 2025-07-14
const MealComponent = ({ props }) => {
  const { selectMealType, mealType, mealTypeInitialState } = props;
  // ##### Komarov 2025-08-05
  const SupplierForm_PleaseSelect = useLocalizedText('SupplierForm_PleaseSelect');

  const mealTypes = [
    useLocalizedText('All Inclusive'),
    useLocalizedText('Full board'),
    useLocalizedText('Breakfast'),
    useLocalizedText('Lunch'),
    useLocalizedText('Dinner'),
    useLocalizedText('Half board'),
    useLocalizedText('Breakfast and Lanch'),
    useLocalizedText('Lunch and Dinner'),
    useLocalizedText('Without Food'),
  ];

  const chooseTypeOfMeal = useLocalizedText('chooseTypeOfMeal');

  return (
    <div className="groupTravelblocks_2" key={uniqueId()}>
      <span>{chooseTypeOfMeal}</span>
      <Select
        onChange={selectMealType}
        bordered={true}
        style={{ minWidth: '5vw' }}
        key={uniqueId()}
        // ##### 24-03-21 Komarov
        value={
          (mealType === mealTypeInitialState && SupplierForm_PleaseSelect) ||
          mealType
        }
      >
        <>
          {
            // ##### 24-03-21 Komarov
            mealTypes?.map(item => (
              <Option value={item} key={item}>
                {item}
              </Option>
            ))
          }
        </>
      </Select>
    </div>
  );
};

// ##### 25-05-21 Komarov
export default MealComponent;
